import React from 'react';

const CarsJcb = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
    >
      <g clipPath="url(#clip0_19672_16109)">
        <path
          d="M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z"
          fill="#CCEAFF"
        />
        <path
          d="M20 11.6745C20 13.0489 18.8861 14.1633 17.5114 14.1633H4V4.32589C4 2.95121 5.11392 1.83679 6.48887 1.83679H19.9999L19.9999 11.6745L20 11.6745Z"
          fill="white"
        />
        <path
          d="M15.5953 8.2159C15.9812 8.22429 16.3693 8.19886 16.7537 8.22911C17.1429 8.30173 17.2368 8.89103 16.8909 9.08402C16.655 9.21117 16.3747 9.13138 16.1188 9.1538H15.5953V8.2159ZM16.9768 7.15433C17.0626 7.45696 16.7708 7.72869 16.4793 7.68701H15.5953C15.6015 7.40161 15.5832 7.09184 15.6043 6.82147C15.9584 6.83144 16.3158 6.80113 16.6679 6.83732C16.8192 6.87533 16.9458 6.99971 16.9768 7.15433ZM19.1044 2.66628C19.1209 3.24424 19.1068 3.85276 19.1115 4.44244C19.1104 6.8399 19.1138 9.23729 19.1096 11.6349C19.0941 12.5334 18.2978 13.3141 17.4055 13.332C16.5124 13.3357 15.6191 13.3326 14.7258 13.3336V9.70914C15.6991 9.70412 16.6729 9.71935 17.6457 9.70155C18.097 9.67321 18.5914 9.37543 18.6124 8.87877C18.6655 8.37997 18.1953 8.03496 17.7488 7.98047C17.5771 7.97601 17.5822 7.93044 17.7488 7.91056C18.1746 7.81852 18.509 7.37777 18.3837 6.93636C18.277 6.4721 17.7638 6.29242 17.337 6.29331C16.4668 6.2874 15.5963 6.29248 14.726 6.29077C14.7317 5.61412 14.7143 4.93676 14.7354 4.26061C14.8043 3.37832 15.6207 2.65073 16.5004 2.66651C17.3685 2.66638 18.2365 2.66638 19.1044 2.66635V2.66628Z"
          fill="url(#paint0_linear_19672_16109)"
        />
        <path
          d="M4.89131 4.35203C4.91354 3.45495 5.71323 2.68062 6.60437 2.66751C7.49421 2.66477 8.38419 2.66712 9.27404 2.66632C9.2716 5.66777 9.27886 8.66954 9.27038 11.6708C9.2361 12.557 8.44512 13.3166 7.5637 13.3323C6.67216 13.3355 5.78053 13.3327 4.88897 13.3336V9.58696C5.75497 9.79155 6.66312 9.87864 7.54659 9.74294C8.07469 9.65797 8.65249 9.39862 8.83128 8.85075C8.96285 8.38209 8.88878 7.88887 8.90836 7.40787V6.29081H7.37942C7.37255 7.0296 7.39349 7.76968 7.36836 8.50759C7.32714 8.96115 6.87797 9.24932 6.45021 9.23393C5.9197 9.23954 4.86843 8.84946 4.86843 8.84946C4.86578 7.46526 4.88382 5.73177 4.89131 4.35216V4.35203Z"
          fill="url(#paint1_linear_19672_16109)"
        />
        <path
          d="M9.84405 6.7413C9.76357 6.75837 9.82787 6.46716 9.8073 6.35669C9.81278 5.65822 9.79584 4.95899 9.81665 4.26102C9.8854 3.375 10.708 2.64559 11.5913 2.66633H14.1926C14.1901 5.66777 14.1974 8.66954 14.1889 11.6708C14.1546 12.557 13.3636 13.3165 12.4821 13.3323C11.5905 13.3356 10.6989 13.3328 9.80727 13.3336V9.22868C10.4162 9.72831 11.2438 9.80608 12.0025 9.80744C12.5744 9.80724 13.143 9.71906 13.6984 9.58716V8.83513C13.0725 9.14708 12.3367 9.34522 11.6428 9.166C11.1588 9.04553 10.8075 8.57776 10.8153 8.07827C10.7592 7.55882 11.0637 7.01042 11.5742 6.85599C12.2079 6.65758 12.8987 6.80933 13.4928 7.06729C13.62 7.13393 13.7492 7.21659 13.6983 7.00384V6.41274C12.7048 6.17635 11.6474 6.08936 10.6492 6.34652C10.3603 6.42803 10.0788 6.55164 9.84405 6.74136V6.7413Z"
          fill="url(#paint2_linear_19672_16109)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_19672_16109"
          x1="14.6959"
          y1="7.77186"
          x2="19.0839"
          y2="7.77186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007B40" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19672_16109"
          x1="4.79567"
          y1="8.10212"
          x2="9.20214"
          y2="8.10212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2970" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19672_16109"
          x1="9.80083"
          y1="7.87524"
          x2="14.1918"
          y2="7.87524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E2B2F" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
        <clipPath id="clip0_19672_16109">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CarsJcb;
